import * as React from 'react'

import * as classnames from 'classnames'
import * as styles from './cover.css'

import { injectStores } from '../../../store'
import { observer } from 'mobx-react'
import { LesenButton, IntroAnsehenButton } from '../../common/elements/buttons'
import { ScrollPageChild } from '../../common/scrollpage'
import { observable, runInAction } from 'mobx'
import { ContentChapter } from '../storydocStoreContent'
// import { Raster } from '../../common/elements/raster'
import { bind } from 'bind-decorator'

import posed from 'react-pose'
import { IntroPlayer } from '../introplayer/introplayer'
import { Drawer } from '../drawer/drawer'
import { replaceFilename } from '../../../utils/StringUtils'
import { colorHexAlpha } from '../../../utils/Color'
import Helmet from 'react-helmet'

const lesenButton = require('../../common/icons/read-chapter.svg')
const lesenButtonMobile = require('../../common/icons/mobile-read-chapter.svg')
const raster = require('../../common/icons/raster.svg')
const transpImg = require('../../common/video/transparent.png')

const overlayProps = {
  open: {
    opacity: 1,
    zIndex: 1,
    transition: {
      zIndex: { duration: 50, ease: 'easeOut' },
      opacity: { duration: 500, ease: 'easeOut' }
    }
  },
  closed: {
    opacity: 0,
    zIndex: -1,
    transition: {
      zIndex: { duration: 50, ease: 'easeIn' },
      opacity: { duration: 500, ease: 'easeIn' }
    }
  }
}

const Overlay = posed.div(overlayProps)

export interface ICover {
  data: ContentChapter
  active: boolean
}

@injectStores
@observer
export class Cover extends ScrollPageChild<ICover> {
  @observable scrollTop = 0
  // @observable playIntro = false
  @observable pauseBg = false
  @observable delayedPlay = false
  @observable buttonHover = false

  element: HTMLDivElement | null = null
  titleElem: HTMLDivElement | null = null
  bottomElement: HTMLDivElement | null = null

  constructor (props: ICover, state: any) {
    super(props, state)
    this.checkDeleayedStart()
  }

  checkDeleayedStart () {
    if (this.props.active) {
      setTimeout(() => {
        runInAction(() => this.delayedPlay = true)
      }, 1000)
      // this.delayedPlay = true
    } else {
      this.delayedPlay = false
    }
  }

  componentDidUpdate () {
    this.checkDeleayedStart()

    if (this.props.active && this.props.scrollPos) {
      if (this.props.scrollPos <= 1) {
        // this.store.storeRouter.push(`${this.store.storeRouter.location.pathname}`)
        this.store.storeCommon.menu.showYellowProgress = true
        this.store.storeCommon.currentStory.paused = false
      } else {
        this.store.storeCommon.currentStory.paused = true
        this.store.storeCommon.menu.showYellowProgress = false
      }
    }
  }

  @bind
  handleClick () {
    if (this.bottomElement && this.bottomElement.scrollIntoView) {
      this.bottomElement.scrollIntoView(
        // { block: 'start', inline: 'nearest', behavior: 'smooth' }
      )
    }
  }

  @bind
  togglePlay () {
    this.store.storeCommon.currentStory.play = !this.store.storeCommon.currentStory.play
    this.store.storeCommon.menu.showProgressBar = !this.store.storeCommon.menu.showProgressBar
  }

  render () {
    // console.log('cover props', this.props)
    let titleWidth: string | number | undefined = undefined
    if (this.titleElem) {
      if (this.titleElem.clientWidth < 0.7 * this.store.storeCommon.window.width) {
        titleWidth = '20ch'
      }
    }

    let background: JSX.Element | null = null
    let imgBackground: JSX.Element | null = null
    if (this.props.data && this.props.data.idx >= 0) {
      if (!this.store.storeCommon.currentStory.play) {
        imgBackground = <div
        className={styles.introBgImage}
        style={{ backgroundImage: `url('${replaceFilename(this.props.data.urlIntroVideo, 'firstframe.jpg')}')` }}
      />
      }

      const videoElem = <IntroPlayer
                          className = {styles.introBgImage}
                          chapter = {this.props.data}
                          onCloseClick = {this.togglePlay}
                          active = {this.props.active}
                          isBg = {!this.store.storeCommon.currentStory.play}
                        />

      if (this.props.data.idx > 0) {
        if ((this.props.active && this.delayedPlay) && (this.props.scrollPos && this.props.scrollPos === 1) && this.store.appStore.online) {
          background = videoElem
        }
      } else {
        background = <div className={classnames(styles.introBgImage, styles.introChapter)} style={{ backgroundImage: `url(${this.props.data.urlOptionalBgImage})` }}></div>
      }
    }

    let colorOverlay: JSX.Element | null = null
    const nextColor = this.props.data && this.props.data.idx < this.store.storyDocContent.chapters.length - 1 ? this.store.storyDocContent.chapters[this.props.data.idx + 1].color : '#000000'
    const color2 = colorHexAlpha(nextColor, 0.3)
    const color1 = colorHexAlpha(this.props.data && this.props.data.color, 0.3)

    colorOverlay = <div className={styles.colorOverlay} style={{
      backgroundImage: `linear-gradient(to right, ${color1} 70%, ${color2}), linear-gradient(rgba(0,0,0,0.2),rgba(0,0,0,0.2)), url(${raster}) `,
      height: this.store.storeCommon.window.height
    }}></div>

    let chapterNumber: JSX.Element | null = null
    if (this.props.data) {
      if (this.store.breakpoints.phone && this.props.data.idx === 0) {
        chapterNumber = null
      } else {
        chapterNumber = <div className={styles.chapterNumber} style={{ opacity: this.props.data.idx > 0 ? 1 : 0 }}>
                          <img src={this.props.data && this.props.data.icon ? this.props.data.icon : transpImg} alt='chapter_number' />
                        </div>
      }
    }

    let textBox: JSX.Element | null = null
    if (this.props.data) {
      const title = this.props.data.idx <= 1 && this.store.storeCommon.window.width < 1000 ? this.props.data.title.replace(/\s/, ' \u000d') : this.props.data.title
      if (this.props.data.idx === 0) {
        textBox = <div className={styles.introTextBox}>
          <div className={styles.introTitle} style={{ width: titleWidth }}>{title}</div>
          <div className={styles.introCaption}>{this.props.data.subline}</div>
        </div>
      } else {
        textBox = <div className={styles.textBox}>
          <div className={styles.title} style={{ width: titleWidth, hyphens: this.props.data.idx === 1 ? undefined : 'auto' }}>{title}</div>
          <div className={styles.caption}>{this.props.data.subline}</div>
        </div>
      }
    }

    let helmet: JSX.Element | null = null
    if (this.props.active && this.props.data && this.props.data.title && this.props.data.description) {
      helmet = <Helmet>
                <title>{this.props.data.title}</title>
                <meta name='description' content={this.props.data.description} />
              </Helmet>
    }

    return (
      <div className={styles.cover} ref={elem => this.element = elem} style={{ height: this.store.storeCommon.window.height }}>
        {helmet}
        {imgBackground}
        {background}
        <Overlay pose={this.store.storeCommon.currentStory.play && this.props.active ? 'closed' : 'open'} key='cover-overlay' className={styles.contentBox} style={{ height: this.store.storeCommon.window.height }}>
          {colorOverlay}
          {this.props.data && this.props.data.idx === 0 ? <Drawer data={this.props.data} /> : null}
          <div
            className={styles.numberAndText}
            ref={elem => this.titleElem = elem}
            style={this.props.data && this.props.data.idx > 0 ?
              { left: this.store.storeCommon.window.width < 640 ? '-50px' : '10vw', paddingRight: '8rem' } :
              { justifyContent: this.store.breakpoints.phone ? 'center' : undefined }}>
            {chapterNumber}
            {textBox}
          </div>
          <div className={styles.buttonsArea}>
            {this.store.appStore.online && this.props.data && this.props.data.idx > 0 && <IntroAnsehenButton className={styles.introAnsehenButton} onClick={this.togglePlay} language={this.store.storeCommon.menu.language}/>}
            <LesenButton className={styles.lesenButton} onClick={this.handleClick} language={this.store.storeCommon.menu.language}>
              <img src={this.store.breakpoints.desktop ? lesenButton : lesenButtonMobile} alt='lesen-button'/>
            </LesenButton>
          </div>
        </Overlay>
        <div className={styles.bottom} ref={elem => this.bottomElement = elem}></div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/storydoc/cover/cover.tsx